// extracted by mini-css-extract-plugin
export default {"carousalC":"Carousal_carousalC__vRXqL","swiper":"Carousal_swiper__i9Edu"};